//
// AGNES - Technical Support Web
//
// Application.js
//
// Copyright (c) 2015 Toyota Central Europe - Czech s.r.o.
//
// Permission is hereby granted, free of charge, to any person
// obtaining a copy of this software and associated documentation
// files (the "Software"), to deal in the Software without
// restriction, including without limitation the rights to use,
// copy, modify, merge, publish, distribute, sublicense, and/or sell
// copies of the Software, and to permit persons to whom the
// Software is furnished to do so, subject to the following
// conditions:
//
// The above copyright notice and this permission notice shall be
// included in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
// EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES
// OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND
// NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT
// HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY,
// WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING
// FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR
// OTHER DEALINGS IN THE SOFTWARE.
//

"use strict";

angular
    .module("Agnes")
    .config([
        "$stateProvider", "$locationProvider",
        function ($stateProvider, $locationProvider) {
            $locationProvider.html5Mode(true);

            $stateProvider
                .state("index", {
                    url: "/",
                    controller: "HomeController",
                    template: require("../Templates/Home.html")
                })
                .state("technical-support-pending", {
                    url: "/technical-support/pending",
                    controller: "TechnicalSupportPendingController",
                    template: require("../Templates/TechnicalSupportPending.html"),
                    resolve: {
                        security: ['$q', '$user', function (q, user) {
                            if (!user.isTechnicalSupportUser) {
                                return q.reject("Not authorized");
                            }
                        }]
                    }
                })
                .state("technical-support-approved", {
                    url: "/technical-support/approved",
                    controller: "TechnicalSupportApprovedController",
                    template: require("../Templates/TechnicalSupportApproved.html"),
                    resolve: {
                        security: ['$q', '$user', function (q, user) {
                            if (!user.isTechnicalSupportUser) {
                                return q.reject("Not authorized");
                            }
                        }]
                    }
                })
                .state("technical-support-browse", {
                    url: "/technical-support/browse",
                    controller: "TechnicalSupportBrowseController",
                    template: require("../Templates/TechnicalSupportBrowse.html"),
                    resolve: {
                        security: ['$q', '$user', function (q, user) {
                            if (!user.isTechnicalSupportUser) {
                                return q.reject("Not authorized");
                            }
                        }]
                    }
                })
                .state("technical-support-evaluation", {
                    url: "/technical-support/evaluation",
                    controller: "TechnicalSupportBrowseEvaluationController",
                    template: require("../Templates/TechnicalSupportBrowseEvaluation.html"),
                    resolve: {
                        security: ['$q', '$user', function (q, user) {
                            if (!user.isTechnicalSupportUser) {
                                return q.reject("Not authorized");
                            }
                        }]
                    }
                })
                .state("technical-support-technical-report", {
                    url: "/technical-support/technical-report",
                    controller: "TechnicalSupportBrowseTechReportController",
                    template: require("../Templates/TechnicalSupportBrowseTechReport.html"),
                    resolve: {
                        security: ['$q', '$user', function (q, user) {
                            if (!user.isTechnicalSupportUser) {
                                return q.reject("Not authorized");
                            }
                        }]
                    }
                })
                .state("technical-support-form-upload", {
                    url: "/technical-support/form-upload/{technicalSupportId}",
                    controller: "TechnicalSupportFormUploadController",
                    template: require("../Templates/TechnicalSupportFormUpload.html"),
                    resolve: {
                        technicalSupportId: [
                            "$stateParams", function ($stateParams) {
                                return $stateParams.technicalSupportId;
                            }
                        ],
                        security: ['$q', '$user', function (q, user) {
                            if (!user.isTechnicalSupportEditor) {
                                return q.reject("Not authorized");
                            }
                        }]
                    }
                })

                .state("technical-support-detail", {
                    url: "/technical-support/detail/{id}",
                    controller: "TechnicalSupportDetailController",
                    template: require("../Templates/TechnicalSupportDetail.html"),
                    resolve: {
                        id: [
                            "$stateParams", function ($stateParams) {
                                return $stateParams.id;
                            }
                        ],
                        security: ['$q', '$user', function (q, user) {
                            if (!user.isTechnicalSupportUser) {
                                return q.reject("Not authorized");
                            }
                        }]
                    }
                })

                .state("warranty-contract-browse", {
                    url: "/warranty-contract/browse?vin",
                    controller: "WarrantyContractBrowseController",
                    template: require("../Templates/WarrantyContractBrowse.html"),
                    resolve: {
                        security: ['$q', '$user', function (q, user) {
                            if (!user.isExtendedWarrantyUser) {
                                return q.reject("Not authorized");
                            }
                        }]
                    }
                })

                .state("warranty-contract-create", {
                    url: "/warranty-contract/create",
                    controller: "WarrantyContractCreateController",
                    template: require("../Templates/WarrantyContractCreate.html"),
                    resolve: {
                        security: ['$q', '$user', function (q, user) {
                            if (!user.isExtendedWarrantyEditor) {
                                return q.reject("Not authorized");
                            }
                        }]
                    }
                })

                .state("menu-pricing-menu", {
                    url: "/menu-pricing/menu",
                    controller: "MenuPricingMenuController",
                    template: require("../Templates/MenuPricingMenu.html"),
                    resolve: {
                        security: ['$q', '$user', function (q, user) {
                            if (!user.isMenuPricingUser) {
                                return q.reject("Not authorized");
                            }
                        }]
                    }
                })

                .state("menu-pricing-catalog", {
                    url: "/menu-pricing/catalog",
                    controller: "MenuPricingCatalogController",
                    template: require("../Templates/MenuPricingCatalog.html"),
                    resolve: {
                        security: ['$q', '$user', function (q, user) {
                            if (!user.isMenuPricingUser) {
                                return q.reject("Not authorized");
                            }
                        }]
                    }
                })

                .state("car-info", {
                    url: "/car-info/{vin}",
                    controller: "CarInfoController",
                    template: require("../Templates/CarInfo.html"),
                    resolve: {
                        vin: [
                            "$stateParams", function ($stateParams) {
                                return $stateParams.vin;
                            }
                        ],
                        security: ['$q', '$user', function (q, user) {
                            if (!user.isAuthenticated) {
                                return q.reject("Not authorized");
                            }
                        }]
                    }
                })
                
                .state("reports", {
                    url: "/reports",
                    controller: "ReportsController",
                    template: require("../Templates/Reports.html"),
                    resolve: {
                        security: ['$q', '$user', function (q, user) {
                            if (!user.isReportReader) {
                                return q.reject("Not authorized");
                            }
                        }]
                    }
                });
        }])